import script from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovesPage.vue?vue&type=script&setup=true&lang=ts"

import "./MovesPage.vue?vue&type=style&index=0&id=09089046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09089046"]])

export default __exports__